// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAccountGetUsersGetUsersResponseModel {
    static getAttributeTypeMap() {
        return ScriptsAccountGetUsersGetUsersResponseModel.attributeTypeMap;
    }
}
ScriptsAccountGetUsersGetUsersResponseModel.discriminator = undefined;
ScriptsAccountGetUsersGetUsersResponseModel.additionalProperties = false;
ScriptsAccountGetUsersGetUsersResponseModel.attributeTypeMap = [
    {
        "name": "userId",
        "baseName": "userId",
        "type": "number"
    },
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsAccountGetUsersGetUsersContactInfoResponseModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsAccountGetUsersGetUsersContactInfoResponseModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsAccountGetUsersGetUsersContactInfoResponseModel"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
    {
        "name": "active",
        "baseName": "active",
        "type": "boolean"
    },
];
//# sourceMappingURL=scriptsAccountGetUsersGetUsersResponseModel.js.map